import { render, staticRenderFns } from "./dialogTrans.vue?vue&type=template&id=1231cc20"
import script from "./dialogTrans.vue?vue&type=script&lang=js"
export * from "./dialogTrans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1231cc20')) {
      api.createRecord('1231cc20', component.options)
    } else {
      api.reload('1231cc20', component.options)
    }
    module.hot.accept("./dialogTrans.vue?vue&type=template&id=1231cc20", function () {
      api.rerender('1231cc20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/user/customerCSG/components/dialogTrans.vue"
export default component.exports